export default __webpack_public_path__ + "static/media/ca-6-rMAX.75455b9a.avif";